import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Users, Briefcase, Award } from 'lucide-react';
import './Community.css';
import SEO from '../components/SEO';

const CommunityPage = () => {
    return (
        <main className="community-gallery">
            <SEO
                title="Community & Impact"
                description="Vision Sports Academy's social responsibility initiatives. Fighting drug abuse and creating professional opportunities for Harare's youth."
            />
            {/* Hero Section */}
            <section className="community-gallery__hero" style={{
                backgroundImage: `linear-gradient(rgba(11, 28, 45, 0.8), rgba(11, 28, 45, 0.8)), url(${require('../Images/community-hero.jpeg')})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
            }}>
                <div className="container">
                    <motion.span
                        className="community-gallery__eyebrow"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                    >
                        Our Social Responsibility
                    </motion.span>
                    <motion.h1
                        className="community-gallery__title"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.1 }}
                    >
                        DEVELOPING <span className="community-gallery__title--accent">PEOPLE</span>,<br />
                        NOT JUST ATHLETES
                    </motion.h1>
                    <motion.p
                        className="community-gallery__subtitle"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2 }}
                    >
                        Through sports, we fight drug abuse, build discipline, and create opportunities for the youth of Harare
                    </motion.p>
                </div>
            </section>

            {/* Drug Abuse Prevention Feature */}
            <section className="community-gallery__feature">
                <div className="community-gallery__feature-content">
                    <motion.div
                        className="community-gallery__feature-text"
                        initial={{ opacity: 0, x: -30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                    >
                        <h2 className="community-gallery__feature-title">
                            FIGHTING <span className="community-gallery__title--accent">DRUG ABUSE</span>
                        </h2>
                        <p className="community-gallery__feature-description">
                            Vision Sports Academy provides a structured alternative to idle time. By engaging youth in high-performance
                            athletics, we instill the discipline and mental toughness needed to resist negative influences and build
                            character that lasts a lifetime.
                        </p>
                        <div className="community-gallery__feature-highlight">
                            <ShieldCheck size={24} className="text-secondary" />
                            <span>Promoting discipline & positive behavior</span>
                        </div>
                    </motion.div>

                    <motion.div
                        className="community-gallery__stats"
                        initial={{ opacity: 0, x: 30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                    >
                        <div className="community-gallery__stat-card community-gallery__stat-card--primary">
                            <h3 className="community-gallery__stat-number community-gallery__stat-number--secondary">500+</h3>
                            <p className="community-gallery__stat-label community-gallery__stat-label--white">Annual Participants</p>
                        </div>
                        <div className="community-gallery__stat-card">
                            <h3 className="community-gallery__stat-number community-gallery__stat-number--primary">100%</h3>
                            <p className="community-gallery__stat-label community-gallery__stat-label--muted">Zero Tolerance Policy</p>
                        </div>
                    </motion.div>
                </div>
            </section>

            {/* Impact Pillars */}
            <section className="community-gallery__pillars">
                <div className="community-gallery__pillars-grid">
                    <motion.article
                        className="community-gallery__pillar"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0, duration: 0.6 }}
                    >
                        <div className="community-gallery__pillar-icon">
                            <Briefcase size={32} />
                        </div>
                        <h4 className="community-gallery__pillar-title">Job Creation</h4>
                        <p className="community-gallery__pillar-description">
                            Empowering local coaches, groundsmen, and administrative staff with professional employment opportunities
                            and career development pathways in the sports industry.
                        </p>
                    </motion.article>

                    <motion.article
                        className="community-gallery__pillar"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.15, duration: 0.6 }}
                    >
                        <div className="community-gallery__pillar-icon">
                            <Award size={32} />
                        </div>
                        <h4 className="community-gallery__pillar-title">Certification</h4>
                        <p className="community-gallery__pillar-description">
                            Facilitating referee and coaching certification courses for young leaders in Groombridge and Borrowdale,
                            creating pathways to professional sports careers.
                        </p>
                    </motion.article>

                    <motion.article
                        className="community-gallery__pillar"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.3, duration: 0.6 }}
                    >
                        <div className="community-gallery__pillar-icon">
                            <Users size={32} />
                        </div>
                        <h4 className="community-gallery__pillar-title">Community Hub</h4>
                        <p className="community-gallery__pillar-description">
                            Partnering with ZB Grounds to transform local facilities into elite sports centers that serve as gathering
                            points for community development and youth empowerment.
                        </p>
                    </motion.article>
                </div>
            </section>
        </main>
    );
};

export default CommunityPage;
